// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { copyUrl } from './assets/modules/copyUrl';
import { externalLink } from './assets/modules/externalLink';
import { fluidEmbed } from './assets/modules/fluidEmbed';
import { popup } from './assets/modules/popup.js';
import { popupURL } from './assets/modules/popupURL';
import { accordion } from './assets/modules/accordion';
import { formSelect } from './assets/modules/form.js';
import { trigger } from './assets/modules/trigger';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe';
import { countdown } from './assets/modules/countdown.js';
import { scrollOpacityFade } from './assets/modules/scrollOpacityFade.js';
import { stickySidebar } from './assets/modules/stickySidebar';
import { filterProgram } from './assets/modules/filterProgram.js';
import { scribble } from './assets/modules/scribble';
import { randomGallery } from './assets/modules/randomGallery.js';
import { accessMap }  from './assets/modules/accessMap';
import Calendar from './assets/modules/calendar';
import { search }  from './assets/modules/search';

const init = () => {
  hover();
  copyUrl();
  externalLink();
  fluidEmbed();
  popup();
  popupURL();
  accordion();
  formSelect();
  trigger();
  initPhotoSwipeFromDOM('.js-pswp-container');
  countdown();
  scrollOpacityFade();
  stickySidebar();
  filterProgram();
  scribble();
  randomGallery();
  accessMap();
  search();
  document.body.classList.add('is-init');
}

init();